// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client'; // IMPORTANT: Import from 'react-dom/client' for React 18+
import App from './App'; // Assuming your main application component is named App.js
import ErrorBoundary from './components/ErrorBoundary'; // Import ErrorBoundary
import './index.css'; // Assuming you have a global CSS file

// Corrected: Import entire module as a namespace to explicitly access Amplify
// This is the most robust way to handle the 'Amplify' import across different package versions.
import * as AmplifyModule from 'aws-amplify';
// Moved: Import awsconfig to the top with other imports to satisfy ESLint's import/first rule.
import awsconfig from './aws-exports';

const Amplify = AmplifyModule.Amplify; // Access Amplify from the named export within the module

// Configure Amplify immediately at the root of your application.
// This ensures that Amplify is fully initialized before any components
// that might make Auth calls are mounted.
Amplify.configure(awsconfig);

// Register a minimal service worker in production so the app can be installed
// as a Progressive Web App (PWA). This does not add offline caching behavior.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    const publicUrl = process.env.PUBLIC_URL || '';
    const swUrl = `${publicUrl}/service-worker.js`;

    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        console.log('Service worker registered:', registration.scope);
      })
      .catch((error) => {
        console.error('Service worker registration failed:', error);
      });
  });
}

// Get the root DOM element where your React app will be mounted
const rootElement = document.getElementById('root');

// Check if the root element exists to prevent errors
if (rootElement) {
  // Create a React root using the new API for React 18+
  const root = ReactDOM.createRoot(rootElement);

  // Render your main application component (App) into the root
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <App /> {/* This is where your App component (which contains Dashboard) is rendered */}
      </ErrorBoundary>
    </React.StrictMode>
  );
} else {
  console.error('Root element with ID "root" not found in the document. Please ensure your public/index.html has <div id="root"></div>');
}

